import { render } from "./GameCell.vue?vue&type=template&id=1684b64f&scoped=true"
import script from "./GameCell.js?vue&type=script&lang=js"
export * from "./GameCell.js?vue&type=script&lang=js"

import "./GameCell.scss?vue&type=style&index=0&id=1684b64f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1684b64f"]])

export default __exports__